var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillBigStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0143 5.77121C12.7881 2.5904 13.6742 1 15 1C16.3258 1 17.2119 2.5904 18.9857 5.77121L19.4449 6.59442C19.9489 7.49882 20.2009 7.95102 20.5929 8.24922C20.9849 8.54742 21.4748 8.65802 22.4548 8.87922L23.3452 9.08082C26.7891 9.86063 28.5097 10.2498 28.9199 11.5672C29.3287 12.8832 28.1555 14.2566 25.8077 17.002L25.2002 17.7119C24.5338 18.4917 24.1992 18.8823 24.0494 19.3639C23.8996 19.8469 23.95 20.3677 24.0508 21.4079L24.1432 22.3557C24.4974 26.0195 24.6752 27.8507 23.6028 28.6641C22.5304 29.4789 20.9177 28.7355 17.6949 27.2515L16.8592 26.8679C15.9436 26.4451 15.4858 26.2351 15 26.2351C14.5142 26.2351 14.0564 26.4451 13.1408 26.8679L12.3065 27.2515C9.08234 28.7355 7.46958 29.4775 6.3986 28.6655C5.32483 27.8507 5.50262 26.0195 5.85681 22.3557L5.94921 21.4093C6.05001 20.3677 6.10041 19.8469 5.94921 19.3653C5.80082 18.8823 5.46622 18.4917 4.79984 17.7133L4.19225 17.002C1.84451 14.258 0.671337 12.8846 1.08013 11.5672C1.49032 10.2498 3.21228 9.85923 6.6562 9.08082L7.54658 8.87922C8.52515 8.65802 9.01374 8.54742 9.40713 8.24922C9.79912 7.95102 10.0511 7.49882 10.5551 6.59442L11.0143 5.77121Z",
    fill: "#FE6F61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillBigStar);
export default __webpack_public_path__ + "static/media/fill_big_star.077f3bccff1768fb0ef7655a14c08bab.svg";
export { ForwardRef as ReactComponent };